import { render, staticRenderFns } from "./adminitem.vue?vue&type=template&id=10451c22&scoped=true&"
import script from "./adminitem.vue?vue&type=script&lang=js&"
export * from "./adminitem.vue?vue&type=script&lang=js&"
import style0 from "./adminitem.vue?vue&type=style&index=0&id=10451c22&lang=scss&scoped=true&"
import style1 from "./adminitem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10451c22",
  null
  
)

component.options.__file = "adminitem.vue"
export default component.exports